import { takeEvery, takeLeading } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from 'app-components/flux/core';

import { transformResponseToTrips, transformTripToRequestData } from 'data/trips/transformers';

import * as actions from './actions';
import { getLastSyncDate } from './selectors';

// ===============================================================================================
// SAGAS functions for trips.  These are the functions responsible for communicating directly
// with external endpoints asynchronously.

// ====================================================
// ACTION WATCHERS to trigger SAGAS calls

const mkResourceConfig = (successAction, failureAction) =>
  resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'trip',
    resourceBaseUrl: '/miles/trips',
    getLastSyncDate,

    transformResponseToResources: transformResponseToTrips,
    transformResourceToRequestData: transformTripToRequestData,

    successAction,
    failureAction,
  });

export function* getTripsActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.getTripsSuccess, actions.getTripsFailure);
  yield takeLeading(actions.getTrips, resourceSagaUtils.qcsSyncGetResources, resourceConfig);
}

export function* createTripActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.createTripSuccess, actions.createTripFailure);
  yield takeEvery(actions.createTrip, resourceSagaUtils.qcsSyncCreateResource, resourceConfig);
}

export function* updateTripActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.updateTripSuccess, actions.updateTripFailure);
  yield takeEvery(actions.updateTrip, resourceSagaUtils.qcsSyncUpdateResource, resourceConfig);
}

export function* deleteTripActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.deleteTripSuccess, actions.deleteTripFailure);
  yield takeEvery(actions.deleteTrip, resourceSagaUtils.qcsSyncDeleteResource, resourceConfig);
}

// ====================================================
// EXPORTS

export default [getTripsActionWatcher, createTripActionWatcher, updateTripActionWatcher, deleteTripActionWatcher];
